import {
  SizeGuideSection
} from "../size-guide-section"

const tableData = {
  title: "Kids' Bibs And Coveralls",
  headers: [
    [
      {
        content: "Kids' Bibs And Coveralls",
        colSpan: 4
      },
    ],
    [
      {
        content: "Size",
        rowSpan: 2 
      },
      {
        content: "Waist(In)",
        rowSpan: 2
      },
      {
        content: "Inseam(In)", 
        rowSpan: 2 
      },
      {
        content: "Hip(In)", 
        rowSpan: 2 
      },
    ],
  ],
  data: [
    [
      {
        content: "4T" 
      },
      {
        content: "19-21" 
      },
      {
        content: "22-24" 
      },
      {
        content: "38-42" 
      },
    ],
    [
      {
        content: "5T" 
      },
      {
        content: "20-22" 
      },
      {
        content: "23-25" 
      },
      {
        content: "42-46" 
      },
    ],
    [
      {
        content: "6T" 
      },
      {
        content: "21-23" 
      },
      {
        content: "24-26" 
      },
      {
        content: "46-48" 
      },
    ],
    [
      {
        content: "8T" 
      },
      {
        content: "24-26" 
      },
      {
        content: "27.5-29.5" 
      },
      {
        content: "51-53" 
      },
    ],
    [
      {
        content: "10T" 
      },
      {
        content: "26-28" 
      },
      {
        content: "30-32" 
      },
      {
        content: "55-58" 
      },
    ],
    [
      {
        content: "12T" 
      },
      {
        content: "27.5-29.5" 
      },
      {
        content: "31.5-33.5" 
      },
      {
        content: "60-63" 
      },
    ],
    [
      {
        content: "14T" 
      },
      {
        content: "29-31" 
      },
      {
        content: "33.5-35.5" 
      },
      {
        content: "65-67" 
      },
    ],
    [
      {
        content: "16T" 
      },
      {
        content: "30.5-32.5" 
      },
      {
        content: "35-37" 
      },
      {
        content: "66-68" 
      },
    ],
  ],
}

export const KidsBibsAndCoveralls = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title='Bibs And Coveralls'
    tableData={tableData}
    className={className}
  />
}